import React from 'react'

import { createStyles, Grid } from '@mui/material'
import { GridProps } from '@mui/material/Grid'
import { withStyles, WithStyles } from '@mui/styles'

const GridItem: React.SFC<GridItemPropsWithStyles> = ({ classes, children, className, ...rest }) => {
  return (
    <Grid item {...rest} className={classes.grid + ' ' + className}>
      {children}
    </Grid>
  )
}

type GridItemPropsWithStyles = GridItemProps & WithStyles<typeof styles>

type GridItemProps = {
  children: React.ReactNode
  className?: string
  xs?: GridProps['xs']
  sm?: GridProps['sm']
  md?: GridProps['md']
  lg?: GridProps['lg']
}

const styles = () =>
  createStyles({
    grid: {
      position: 'relative',
      width: '100%',
      minHeight: '1px',
      paddingRight: '15px',
      paddingLeft: '15px',
      flexBasis: 'auto',
    },
  })

export default withStyles(styles)(GridItem)
